import React, { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import Wizard from "../wizard/wizard";
import DialogContent from './dialog-content'
import { WS_URL } from "../../constants/ws-constants";
import WSPluginService from "../../services/wsPluginService/wsPluginService";
import { COMMAND_STATE, ENROLL_TYPE, MONITORING_COMMAND, MONITORING_COMMAND_STATE } from "../../constants/command-status";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { toast } from "react-toastify";
import { useLocale } from "../../contexts/localeContext";

import FullScreenActivityFrame from '../activity-frame/full-screen-activity-spinner';

type Props = {
    onClose: () => void;
    isOpen: boolean;
    onSave?: (formFields) => void;
    masterImages?: any,
    onSelectedImage?: any,
    selectedImage?: any
    handleImageDelete?: any
    setUploadNewImage?: any
    onSetPrimary?: any
};

const ImageDialogWizard: FC<Props> = ({ onClose, isOpen, masterImages, onSelectedImage, selectedImage, handleImageDelete, setUploadNewImage, onSetPrimary }) => {
    const [step, setStep] = useState(0);
    const { translate } = useLocale();
    const [pluginWSInstance, setPluginWSInstance] = useState<WebSocket | undefined>();  // needed for image capture via webcam
    const [busyScanning, setBusyScanning] = useState<boolean>(false);

    const closeWizard = () => {
        onClose();
    };
    const getContentPages = () => {
        const pages = [<DialogContent setUploadNewImage={setUploadNewImage} handleImageDelete={handleImageDelete} selectedImage={selectedImage} onNext={() => {}} pluginWSInstance={pluginWSInstance} setBusyScanning={setBusyScanning}/>];
        return pages.concat([]);
    };

    const onMessage = (response: any) => {
        const jsonData = JSON.parse(response.data);
        if (jsonData.command === MONITORING_COMMAND.MONITORING_ENROL && jsonData.attributes.subCommand === ENROLL_TYPE.ENROLL_IDEMIA_FINGER) {
            if (jsonData.attributes.cmdState === COMMAND_STATE.COMMAND_COMPLETE) {
                toast.success(translate.byKey(TranslationKeys.enrolmentSaved));
            }
            else {
                toast.success(jsonData.attributes.errMessage);
            }
            onClose();
            setBusyScanning(false);
        }
    }
    
    const onWebSocketError = (error) => {
        console.log('Plugin Manager not detected. Some enrolment capabilities will be unavailable.');
        setPluginWSInstance(undefined);
    };

    const onWebSocketClosed = (e) => {
        setPluginWSInstance(undefined);
    };

    const onWebSocketOpen = (instance, value) => {
        // set the instance so we can use anywhere here
        setPluginWSInstance(instance);
    };
    
    return (
        <>
        {busyScanning ? <FullScreenActivityFrame message={translate.byKey(TranslationKeys.scanning)} /> : null}
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            onRequestClose={closeWizard}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <WSPluginService
                 onMessage={onMessage}
                 onOpen={onWebSocketOpen}
                 onError={onWebSocketError}
                 onClosed={onWebSocketClosed}
                url={window.location.protocol === "https:" ? WS_URL.SECURED_PLUGIN_MANAGER_WEBSOCKET : WS_URL.UNSECURED_PLUGIN_MANAGER_WEBSOCKET} 
                />
                <Wizard
                    name={'Image Editor'}
                    step={step}
                    onClose={closeWizard}
                    masterImages={masterImages}
                    onSelectedImage={onSelectedImage}
                    onSetPrimary={onSetPrimary}
                >
                    {getContentPages()}
                </Wizard>
        </Modal>
        </>
    );
};

export default ImageDialogWizard;
